__turbopack_context__.v({
  "section": "affirm-content-module-scss-module__sIZ4iG__section",
});
